import { Tooltip } from 'antd';
import { Info } from '@phosphor-icons/react';
import {
  BottomCard as Card,
  BottomCardHeader2,
} from './styles';

type StatusConfig = {
  label: string;
  color: string;
  bg: string;
  border: string;
};

type Props = {
  label: string;
  value: string | number;
  helpText?: string;
  statusLabel?: string;
  statusValue?: string;
  statusConfig?: StatusConfig;
  openModal?: (value: boolean) => void;
};

export const BottomCardGraphic5 = ({
  label,
  value,
  helpText,
  statusLabel = 'Saúde Financeira',
  statusValue = 'Boa',
  statusConfig,
  openModal,
}: Props) => {
  const badge = statusConfig || {
    label: statusValue,
    color: '#52C41A',
    bg: '#F6FFED',
    border: '#B7EB8F',
  };

  return (
    <Card
      onClick={() => {
        openModal && openModal(true);
      }}
      style={{
        gap: '.6rem',
        minHeight: '110px',
        justifyContent: 'space-between',
      }}
    >
      <BottomCardHeader2>
        <span>{label}</span>
        <Tooltip title={helpText}>
          <Info size="1rem" color="#EC6643" />
        </Tooltip>
      </BottomCardHeader2>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '.45rem',
        }}
      >
        <strong
          style={{
            fontSize: '2rem',
            lineHeight: 1.1,
            color: '#111827',
            fontWeight: 700,
          }}
        >
          {value}
        </strong>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '.5rem',
            flexWrap: 'wrap',
          }}
        >
          <span
            style={{
              fontSize: '12px',
              color: '#9CA3AF',
            }}
          >
            {statusLabel}
          </span>

          <span
            style={{
              fontSize: '11px',
              fontWeight: 600,
              color: badge.color,
              background: badge.bg,
              border: `1px solid ${badge.border}`,
              borderRadius: '999px',
              padding: '2px 8px',
              lineHeight: 1.2,
            }}
          >
            {badge.label}
          </span>
        </div>
      </div>
    </Card>
  );
};